import {Entity} from '../api/entity.interface';
import {DRAFT_TYPE, DraftPhoto} from './event-draft.model';

/** The onboarding first-activity step's single draft slot per user. */
export const FIRST_ACTIVITY_DRAFT_ID = 'onboarding-first-activity';

/**
 * The persisted in-flight state of the guided onboarding's first-activity
 * step (HEC-178). Plain data only, like EventDraft; the start time is an
 * ISO string and photos are identities of files already on the device.
 */
export interface FirstActivityDraft extends Entity<string> {
  type: typeof DRAFT_TYPE;
  id: typeof FIRST_ACTIVITY_DRAFT_ID;
  eventId: string;
  name: string;
  startTime: string;
  selectedDuration: number;
  selectedCategoryName: string | null;
  photos: DraftPhoto[];
  savedAt: string;
}
